
import { getChatUnreadMessageCount } from '@/state/messenger/useGroupsUnreadMessages';
import useMessengerState from '@/state/messenger/messengerState';
import { CHAT_TYPE_FORUM, CHAT_TYPE_GROUP } from '@/models/Messenger';
import { computed, defineComponent, watch } from 'vue';

export default defineComponent({
  name: 'BCXMessengerFilters',
  setup() {
    const {
      groupFilters: filters, chats, chatgroups, perGroupMeta
    } = useMessengerState();

    const toggle = (selectedKey:string) => {
      Object.keys(filters as any).forEach((key) => { (filters as any)[key] = key === selectedKey; });
    };

    const hasForumChats = computed(() => chats.value.some(({ type }) => type === CHAT_TYPE_FORUM));
    const hasCompactGap = computed(() => hasForumChats.value || chatgroups.value.length > 0);
    const visibleKeys = computed(() => Object.keys(filters as any)
      .filter((key) => (key !== CHAT_TYPE_GROUP || chatgroups.value.length > 0)
        && (key !== CHAT_TYPE_FORUM || hasForumChats.value)));

    watch(hasForumChats, (hasChats) => {
      if (!hasChats && filters[CHAT_TYPE_FORUM]) {
        filters[CHAT_TYPE_FORUM] = false;
        filters.all = true;
      }
    }, { immediate: true });

    const unreadCounter = computed<Record<string, number>>(() => {
      const readCounter: Record<string, number> = {};
      chats.value.forEach((chat) => {
        const key = chat.type;
        readCounter[key] = (readCounter[key] ?? 0) + getChatUnreadMessageCount(chat);
      });
      // Chat groups live outside `chats`; their unread counts come from perGroupMeta.
      readCounter[CHAT_TYPE_GROUP] = chatgroups.value.reduce(
        (sum, g) => sum + (perGroupMeta.value[g.groupId]?.unreadCount ?? 0), 0
      );
      return readCounter;
    });

    // inclusive toggle:

    // const toggle = (key:string) => {
    //   if (key === 'all') {
    //     Object.keys(filters as any).forEach((key) => { filters[key] = key === 'all'; });
    //   } else {
    //     filters[key] = !filters[key];
    //     filters.all = !Object.values(filters).includes(true);
    //   }
    // };

    return {
      toggle,
      filters,
      hasCompactGap,
      visibleKeys,
      unreadCounter
    };
  },
});
